export enum AUTH_CONSTANTS  {
    ROLEID = 1,
  }

export const REFRESH_TOKEN_HEADER = 'x-auth-token';

